module.exports = __webpack_public_path__ + "static/img/案例5.23793f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/案例5.png
// module id = rcQb
// module chunks = 0